import swal from "sweetalert";

export const refOptions = [
    {data_value:0,value:'INVALID_RELATION',name:'INVALID_RELATION'},
    {data_value:1,value:'TRIP_LESS_THAN',name:'TRIP_LESS_THAN'},
    {data_value:2,value:'TRIP_LESS_THAN_OR_EQUAL',name:'TRIP_LESS_THAN_OR_EQUAL'},
    {data_value:3,value:'TRIP_EQUAL',name:'TRIP_EQUAL'},
    {data_value:4,value:'TRIP_GREATER_THAN_OR_EQUAL',name:'TRIP_GREATER_THAN_OR_EQUAL'},
    {data_value:5,value:'TRIP_GREATER_THAN',name:'TRIP_GREATER_THAN'},
    {data_value:6,value:'TRIP_NOT_EQUAL',name:'TRIP_NOT_EQUAL'}
];


export const eventTypeOptions = [
    {data_value:0,name:'INVALID',value:'INVALID'},
    {data_value:1,name:'NOTICE',value:'NOTICE'},
    {data_value:2,name:'STATUS',value:'STATUS'},
    {data_value:3,name:'WARNING',value:'WARNING'},
    {data_value:10,name:'STICKY_WARNING',value:'STICKY_WARNING'},
    {data_value:4,name:'COOL_STOP',value:'COOL_STOP'},
    {data_value:5,name:'HOT_STOP',value:'HOT_STOP'},
    {data_value:6,name:'EXP_AUTO_COOL_STOP',value:'EXP_AUTO_COOL_STOP'},
    {data_value:7,name:'EXP_AUTO_HOT_STOP',value:'EXP_AUTO_HOT_STOP'},
    {data_value:8,name:'FIX_AUTO_COOL_STOP',value:'FIX_AUTO_COOL_STOP'},
    {data_value:9,name:'FIX_AUTO_HOT_STOP',value:'FIX_AUTO_HOT_STOP'}
];

export const changeByOptions = [
    {value:'1',name:'Change Address'},
    {value:'2',name:'Change Value'}
];

export const optionsLeft = [
    {value:'i0',name:'Sheet - I0'},
    {value:'i5',name:'Sheet - I5'},
    {value:'i8',name:'Sheet - I8'},
    {value:'m1',name:'Sheet - M1'}
];

export const optionsRight = [
    {value:'m0',name:'Sheet - M0'},
    {value:'q0',name:'Sheet - Q0'}
];

export const options = [
    {value:'i0',name:'Sheet - I0'},
    {value:'i5',name:'Sheet - I5'},
    {value:'i8',name:'Sheet - I8'},
    {value:'m0',name:'Sheet - M0'},
    {value:'m1',name:'Sheet - M1'},
    {value:'q0',name:'Sheet - Q0'}
];

export const modbusOptions = [
    {value:'i0',name:'Sheet - I0'},
    {value:'i5',name:'Sheet - I5'},
    {value:'i8',name:'Sheet - I8'},
    {value:'m0',name:'Sheet - M0'},
    {value:'m1',name:'Sheet - M1'},
    //{value:'m3',name:'Sheet - M3'},
    {value:'q0',name:'Sheet - Q0'}
];


export const ECMID = [
    {value:0,name:'0'},
    {value:1,name:'1'},
    {value:2,name:'2'},
    {value:3,name:'3'},
    {value:4,name:'4'},
    {value:5,name:'5'},
    {value:6,name:'6'},
    {value:7,name:'7'},
];

export const sheetOptionECUReceiveMessage = [
    {value:'i5',name:'Sheet - I5'},
];

export const oopsSweetAlert = (response)  => {
    swal({
        title: 'Oops!',
        text: response.message,
        icon: "error",
        dangerMode: true,
    });
};

export const errorSweetAlert = (response)  => {
    swal({
        title: 'Error',
        text: response.message,
        icon: "error",
        dangerMode: true,
    });
};

export const paramOptions = [
    {value:'i0',name:'Sheet - I0'},
    {value:'i8',name:'Sheet - I8'},
    {value:'m0',name:'Sheet - M0'},
    {value:'m1',name:'Sheet - M1'},
    {value:'q0',name:'Sheet - Q0'}
];

export const paramColumns = [
    { id: 'Actions', label: 'Actions' , minWidth: 150},
    { id: 'Addr', label: 'Address' },
    { id: 'ETxt', label: 'English Text', minWidth: 160},
    { id: 'FTxt', label: 'French Text', minWidth: 160 },
    { id: 'STxt', label: 'Spanish Text', minWidth: 165},
    { id: 'GTxt', label: 'German Text', minWidth: 165 },
    { id: 'ITxt', label: 'Italian Text', minWidth: 160},
    { id: 'DTxt', label: 'Dutch Text', minWidth: 160 },
    { id: 'NTxt', label: 'Norwegian Text', minWidth: 190},
    { id: 'PTxt', label: 'Polish Text', minWidth: 160 },
    { id: 'PeTxt', label: 'Portuguese Text', minWidth: 190},
    { id: 'TTxt', label: 'Turkish Text' },
    { id: 'CTxt', label: 'Chinese Text'},
    { id: 'RTxt', label: 'Russian Text' },
    { id: 'Min', label: 'Min Value'},
    { id: 'Max', label: 'Max Value' },
    { id: 'Val', label: 'Value' },
    { id: 'Unit', label: 'Units'},
    { id: 'RAccs', label: 'Read Access' },
    { id: 'WAccs', label: 'Write Access'},
    { id: 'GType', label: 'Gauge' },
];


export const paramLabels = {
    Addr:  'Address',
    ETxt:  'English Text',
    FTxt:  'French Text',
    STxt:  'Spanish Text',
    GTxt:  'German Text',
    ITxt:  'Italian Text',
    DTxt:  'Dutch Text',
    NTxt:  'Norwegian Text',
    PTxt:  'Polish Text',
    PeTxt: 'Portuguese Text',
    TTxt:  'Turkish Text',
    CTxt:  'Chinese Text',
    RTxt:  'Russian Text',
    Min:   'Min Value',
    Max:   'Max Value',
    Val:   'Value',
    Unit:  'Units',
    RAccs: 'Read Access',
    WAccs: 'Write Access',
    GType: 'Gauge',
    GName: 'SiteTech Group',
    CST: 'Custom Text',
};

export const AccessGroup = [
    // {data_value:0,value:'User',name:'User'},
    // {data_value:1,value:'Operator',name:'Operator'},
    // {data_value:2,value:'Technician',name:'Technician'},
    // {data_value:3,value:'Factory',name:'Factory'},
    // {data_value:4,value:'None',name:'None'},
    // {data_value:5,value:'Hidden',name:'Hidden'}
    {value:'User',name:'User'},
    {value:'Operator',name:'Operator'},
    {value:'Technician',name:'Technician'},
    {value:'Factory',name:'Factory'},
    {value:'None',name:'None'},
    {value:'Hidden',name:'Hidden'}
];

export const GaugeType = [
    // {data_value:0,value:'None',name:'None'},
    // {data_value:1,value:'FullGauge',name:'Full Gauge'},
    // {data_value:2,value:'HalfGauge',name:'Half Gauge'},
    // {data_value:3,value:'VerticalBar',name:'Vertical Bar'},
    // {data_value:4,value:'HorizontalBar',name:'Horizontal Bar'}
    {value:'None',name:'None'},
    {value:'FullGauge',name:'Full Gauge'},
    {value:'HalfGauge',name:'Half Gauge'},
    {value:'VerticalBar',name:'Vertical Bar'},
    {value:'HorizontalBar',name:'Horizontal Bar'}
];


export const UnitOptions = [
    {data_value:0,name:' NA ',value:' '},
    {data_value:1,name:'V_V_V',value:'V_V_V'},
    {data_value:2,name:'V_mV_mV',value:'V_mV_mV'},
    {data_value:3,name:'V_KV_KV',value:'V_KV_KV'},
    {data_value:4,name:'V_MV_MV',value:'V_MV_MV'},
    {data_value:5,name:'mV_mV_mV',value:'mV_mV_mV'},
    {data_value:6,name:'mV_V_V',value:'mV_V_V'},
    {data_value:7,name:'mV_KV_KV',value:'mV_KV_KV'},
    {data_value:8,name:'mV_MV_MV',value:'mV_MV_MV'},
    {data_value:9,name:'KV_KV_KV',value:'KV_KV_KV'},
    {data_value:10,name:'KV_V_V',value:'KV_V_V'},
    {data_value:11,name:'KV_mV_mV',value:'KV_mV_mV'},
    {data_value:12,name:'KV_MV_MV',value:'KV_MV_MV'},
    {data_value:13,name:'MV_MV_MV',value:'MV_MV_MV'},
    {data_value:14,name:'MV_V_V',value:'MV_V_V'},
    {data_value:15,name:'MV_mV_mV',value:'MV_mV_mV'},
    {data_value:16,name:'MV_KV_KV',value:'MV_KV_KV'},
    {data_value:17,name:'W_W_W',value:'W_W_W'},
    {data_value:18,name:'W_KW_KW',value:'W_KW_KW'},
    {data_value:19,name:'W_MW_MW',value:'W_MW_MW'},
    {data_value:20,name:'KW_KW_KW',value:'KW_KW_KW'},
    {data_value:21,name:'KW_W_W',value:'KW_W_W'},
    {data_value:22,name:'KW_MW_MW',value:'KW_MW_MW'},
    {data_value:23,name:'MW_MW_MW',value:'MW_MW_MW'},
    {data_value:24,name:'MW_W_W',value:'MW_W_W'},
    {data_value:25,name:'MW_KW_KW',value:'MW_KW_KW'},
    {data_value:26,name:'VA_VA_VA',value:'VA_VA_VA'},
    {data_value:27,name:'VA_KVA_KVA',value:'VA_KVA_KVA'},
    {data_value:28,name:'VA_MVA_MVA',value:'VA_MVA_MVA'},
    {data_value:29,name:'KVA_KVA_KVA',value:'KVA_KVA_KVA'},
    {data_value:30,name:'KVA_VA_VA',value:'KVA_VA_VA'},
    {data_value:31,name:'KVA_MVA_MVA',value:'KVA_MVA_MVA'},
    {data_value:32,name:'MVA_MVA_MVA',value:'MVA_MVA_MVA'},
    {data_value:33,name:'MVA_VA_VA',value:'MVA_VA_VA'},
    {data_value:34,name:'MVA_KVA_KVA',value:'MVA_KVA_KVA'},
    {data_value:35,name:'VAR_VAR_VAR',value:'VAR_VAR_VAR'},
    {data_value:36,name:'VAR_KVAR_KVAR',value:'VAR_KVAR_KVAR'},
    {data_value:37,name:'VAR_MVAR_MVAR',value:'VAR_MVAR_MVAR'},
    {data_value:38,name:'KVAR_KVAR_KVAR',value:'KVAR_KVAR_KVAR'},
    {data_value:39,name:'KVAR_VAR_VAR',value:'KVAR_VAR_VAR'},
    {data_value:40,name:'KVAR_MVAR_MVAR',value:'KVAR_MVAR_MVAR'},
    {data_value:41,name:'MVAR_MVAR_MVAR',value:'MVAR_MVAR_MVAR'},
    {data_value:42,name:'MVAR_VAR_VAR',value:'MVAR_VAR_VAR'},
    {data_value:43,name:'MVAR_KVAR_KVAR',value:'MVAR_KVAR_KVAR'},
    {data_value:44,name:'uA_Ua_uA',value:'uA_Ua_uA'},
    {data_value:45,name:'uA_mA_mA',value:'uA_mA_mA'},
    {data_value:46,name:'uA_A_A',value:'uA_A_A'},
    {data_value:47,name:'uA_KA_KA',value:'uA_KA_KA'},
    {data_value:48,name:'mA_mA_mA',value:'mA_mA_mA'},
    {data_value:49,name:'mA_uA_uA',value:'mA_uA_uA'},
    {data_value:50,name:'mA_A_A',value:'mA_A_A'},
    {data_value:51,name:'mA_KA_KA',value:'mA_KA_KA'},
    {data_value:52,name:'A_A_A',value:'A_A_A'},
    {data_value:53,name:'A_uA_uA',value:'A_uA_uA'},
    {data_value:54,name:'A_mA_mA',value:'A_mA_mA'},
    {data_value:55,name:'A_KA_KA',value:'A_KA_KA'},
    {data_value:56,name:'KA_KA_KA',value:'KA_KA_KA'},
    {data_value:57,name:'KA_uA_uA',value:'KA_uA_uA'},
    {data_value:58,name:'KA_mA_mA',value:'KA_mA_mA'},
    {data_value:59,name:'KA_A_A',value:'KA_A_A'},
    {data_value:60,name:'KPA_KPA_PSI',value:'KPA_KPA_PSI'},
    {data_value:61,name:'KPA_MPA_PSI',value:'KPA_MPA_PSI'},
    {data_value:62,name:'KPA_BAR_PSI',value:'KPA_BAR_PSI'},
    {data_value:63,name:'MPA_MPA_PSI',value:'MPA_MPA_PSI'},
    {data_value:64,name:'MPA_KPA_PSI',value:'MPA_KPA_PSI'},
    {data_value:65,name:'MPA_BAR_PSI',value:'MPA_BAR_PSI'},
    {data_value:66,name:'BAR_BAR_BAR',value:'BAR_BAR_BAR'},
    {data_value:67,name:'BAR_KPA_PSI',value:'BAR_KPA_PSI'},
    {data_value:68,name:'BAR_MPA_PSI',value:'BAR_MPA_PSI'},
    {data_value:69,name:'C_C_F',value:'C_C_F'},
    {data_value:70,name:'C_K_F',value:'C_K_F'},
    {data_value:71,name:'K_K_R',value:'K_K_R'},
    {data_value:72,name:'K_C_F',value:'K_C_F'},
    {data_value:73,name:'Wh_Wh_Wh',value:'Wh_Wh_Wh'},
    {data_value:74,name:'KWh_Wh_Wh',value:'KWh_Wh_Wh'},
    {data_value:75,name:'Wh_KWh_KWh',value:'Wh_KWh_KWh'},
    {data_value:76,name:'KWh_KWh_KWh',value:'KWh_KWh_KWh'},
    {data_value:77,name:'Wh_MWh_MWh',value:'Wh_MWh_MWh'},
    {data_value:78,name:'MWh_MWh_MWh',value:'MWh_MWh_MWh'},
    {data_value:79,name:'KWh_MWh_MWh',value:'KWh_MWh_MWh'},
    {data_value:80,name:'MWh_KWh_KWh',value:'MWh_KWh_KWh'},
    {data_value:81,name:'MWh_Wh_Wh',value:'MWh_Wh_Wh'},
    {data_value:82,name:'WattSec_WattSec_WattSec',value:'WattSec_WattSec_WattSec'},
    {data_value:83,name:'VARh_VARh_VARh',value:'VARh_VARh_VARh'},
    {data_value:84,name:'VARh_KARh_KARh',value:'VARh_KARh_KARh'},
    {data_value:85,name:'KVARh_KVARh_KVARh',value:'KVARh_KVARh_KVARh'},
    {data_value:86,name:'KVARh_VARh_VARh',value:'KVARh_VARh_VARh'},
    {data_value:87,name:'VARh_MVARh_MVARh',value:'VARh_MVARh_MVARh'},
    {data_value:88,name:'KVARh_MVARh_MVARh',value:'KVARh_MVARh_MVARh'},
    {data_value:89,name:'MVARh_MVARh_MVARh',value:'MVARh_MVARh_MVARh'},
    {data_value:90,name:'MVARh_VARh_VARh',value:'MVARh_VARh_VARh'},
    {data_value:91,name:'MVARh_KVARh_KVARh',value:'MVARh_KVARh_KVARh'},
    {data_value:92,name:'VarSec_VarSec_VarSec',value:'VarSec_VarSec_VarSec'},
    {data_value:93,name:'L_L_G',value:'L_L_G'},
    {data_value:94,name:'L/Hr_L/Hr_G/Hr',value:'L/Hr_L/Hr_G/Hr'},
    {data_value:95,name:'sec_sec_sec',value:'sec_sec_sec'},
    {data_value:96,name:'msec_msec_msec',value:'msec_msec_msec'},
    {data_value:97,name:'min_min_min',value:'min_min_min'},
    {data_value:98,name:'hour_hour_hour',value:'hour_hour_hour'},
    {data_value:99,name:'DD_DD_DD',value:'DD_DD_DD'},
    {data_value:100,name:'MM_MM_MM',value:'MM_MM_MM'},
    {data_value:101,name:'YY_YY_YY',value:'YY_YY_YY'},
    {data_value:102,name:'Hz_Hz_Hz',value:'Hz_Hz_Hz'},
    {data_value:103,name:'%_%_%',value:'%_%_%'},
    {data_value:104,name:'RPM_RPM_RPM',value:'RPM_RPM_RPM'},
    {data_value:105,name:'Ohm_Ohm_Ohm',value:'Ohm_Ohm_Ohm'},
    {data_value:106,name:'deg_deg_deg',value:'deg_deg_deg'}
];


export const DefaultSiteTechGroup = [
    // {data_value:0,value:'Alternator',name:'Alternator'},
    // {data_value:1,value:'Engine',name:'Engine'},
    // {data_value:2,value:'Controller Inputs',name:'Controller Inputs'},
    // {data_value:3,value:'CAN Module',name:'CAN Module'},
    // {data_value:4,value:'Protection',name:'Protection'},
    // {data_value:5,value:'Communications',name:'Communications'},
    // {data_value:6,value:'OpRecords',name:'OpRecords'},
    // {data_value:7,value:'System',name:'System'},
    // {data_value:8,value:'General',name:'General'},
    // {data_value:9,value:'ACPowerMetering',name:'ACPowerMetering'},
    
    {value:'Alternator',name:'Alternator'},
    {value:'Engine',name:'Engine'},
    {value:'Controller Inputs',name:'Controller Inputs'},
    {value:'CAN Module',name:'CAN Module'},
    {value:'Protection',name:'Protection'},
    {value:'Communications',name:'Communications'},
    {value:'OpRecords',name:'OpRecords'},
    {value:'System',name:'System'},
    {value:'General',name:'General'},
];


export const BaudRateOptions= [
    {value:'0',name:'None'},
    {value:'1',name:'Bps9600 (9600)'},
    {value:'2',name:'Bps19200 (19200)'},
    {value:'3',name:'Bps38400 (38400)'},
    {value:'4',name:'Bps57600 (57600)'},
    {value:'5',name:'Bps115200 (115200)'}
];


export const ExerciseStateOptions= [
    {value:'0',name:'NotStarted'},
    {value:'1',name:'Standby'},
    {value:'2',name:'Standby2'},
    {value:'3',name:'Standby3'},
    {value:'4',name:'Standby4'},
    {value:'5',name:'Running'},
    {value:'6',name:'Idle'},
    {value:'7',name:'Cancelled'},
    {value:'8',name:'Completed'}
];

export const SensorSelectOptions= [
    {value:'0',name:'unused'},
    {value:'1',name:'Resistive'},
    {value:'2',name:'SwitchVal'},
    {value:'3',name:'CANsender'},
];


export const LeadingLaggingNgcOptions= [
    {value:'0',name:'Leading'},
    {value:'1',name:'Lagging'},
];

export const boolOptions= [
    {value:false,name:'FALSE'},
    {value:true,name:'TRUE'},
];

export const OnOffBooleanOptions= [
    {value:false,name:'Off'},
    {value:true,name:'On'},
];

export const ActiveInactiveBooleanOptions= [
    {value:false,name:'Inactive'},
    {value:true,name:'Active'},
];

export const YesNoBooleanOptions= [
    {value:false,name:'No'},
    {value:true,name:'Yes'},
];

export const OpenClosedBooleanOptions= [
    {value:false,name:'Open'},
    {value:true,name:'Closed'},
];

export const PhaseRotationBooleanOptions= [
    {value:false,name:'ABC'},
    {value:true,name:'CBA'},
];

export const VoltagePhaseConnectionOptions= [
    {value:'0',name:'SinglePhase'},
    {value:'1',name:'SinglePhaseDogleg'},
    {value:'2',name:'ThreePhaseWye'},
    {value:'3',name:'ThreePhaseDelta'},
];

export const GenControllerStateOptions= [
    {value:'1',name:'Init'},
    {value:'2',name:'Auto_Standby'},
    {value:'4',name:'Fault'},
    {value:'5',name:'Stop'},
    {value:'6',name:'Auto_Idle'},
    {value:'7',name:'Auto_Run'},
    {value:'8',name:'AutoCooldown'},
    {value:'9',name:'LPM'},
];


export const PowerApplicationModeOptions= [
    {value:'0',name:'Standby'},
    {value:'1',name:'Prime'},
];

export const RedundantStarterModeOptions= [
    {value:'0',name:'Disabled'},
    {value:'1',name:'SwitchOnStart'},
];

export const FuelTypeOptions= [
    {value:'0',name:'NaturalGas'},
    {value:'1',name:'LiquidPropane'},
    {value:'2',name:'Gasoline'},
    {value:'3',name:'Diesel'},
    {value:'15',name:'Unknown'},
];


export const EngineSequencerStateOptions= [
    {value:'0',name:'Invalid'},
    {value:'1',name:'Stopped'},
    {value:'2',name:'Standby'},
    {value:'3',name:'ShutDown'},
    {value:'4',name:'WaitToStart'},
    {value:'5',name:'PeriodicLube'},
    {value:'6',name:'PreLubing'},
    {value:'7',name:'StarterEngaged'},
    {value:'8',name:'Cranking'},
    {value:'9',name:'CrankPause'},
    {value:'10',name:'Running'},
    {value:'11',name:'CoolDown'},
    {value:'12',name:'Stopping'},
    {value:'13',name:'StoppedWithEcmPower'},
    {value:'14',name:'Stalled'},
];

export const checkBooleanVal = (val) => {
    const rawValue = val;
    const selectVal =
    rawValue === true ||
    rawValue === 1 ||
    rawValue === "1" ||
    rawValue === "true"
        ? true
        : rawValue === false ||
        rawValue === 0 ||
        rawValue === "0" ||
        rawValue === "false"
        ? false
        : null;
    return selectVal
}

//export const finalVal = 
